module.exports = __webpack_public_path__ + "static/img/t40.844f6857.png";